import React, { memo, useContext } from "react";
import { useNavigate } from "react-router-dom";
import { CTX_STATE, disCount, specialNavigate, countdown } from "../common";

function App(props) {
	const { list = [], nav: index, from } = props;
	const isWjyz = from === "wjyz" ? true : false;
	const navigate = useNavigate();
	const _state = useContext(CTX_STATE);

	const goMore = () => {
		specialNavigate("/AllGame", _state.token, navigate, isWjyz, { index });
	};

	//网吧版兼容
	const isNetbar = window.mbQuery?.appInfo?.type === "netbar";

	return (
		<div className="content">
			{list.map((ele, index) => {
				const more_text = isWjyz ? "Steam热销" : "Steam热销游戏";
				const list_img = isWjyz
					? `url(https://cdn-wjyz.wanjiayizhan.com${encodeURI(ele.img_url)})`
					: `url(${ele.list_img})`;
				const discount = isWjyz
					? disCount(ele.price, ele.special_price)
					: disCount(ele.source_price, ele.group_vip_price);
				const product_name = isWjyz ? ele.name : ele.product_name;
				const origin_price = isWjyz ? ele.price / 100 : ele.source_price;
				const price = isWjyz ? ele.special_price / 100 : ele.group_vip_price;
				const canFreePlay = countdown(ele.created_at) <= 0;

				return index === 19 ? (
					<div className="list-item more-game" key={index} onClick={goMore}>
						<div className="up"></div>
						<div className="down">{more_text}</div>
					</div>
				) : (
					<div
						className="list-item"
						key={index}
						onClick={() => {
							specialNavigate("/Goods", _state.token, navigate, isWjyz, ele);
						}}
					>
						<div
							className="up"
							style={{
								backgroundImage: list_img,
							}}
						>
							{!!discount && <div>-{discount}%</div>}
						</div>
						<div className="down">
							<div title={product_name}>{product_name}</div>
							<div>
								{!!discount && (
									<div className="origin-price">￥{origin_price}</div>
								)}
								<div className="price">
									{!isWjyz && canFreePlay && isNetbar ? "免费" : `￥${price}`}
								</div>
							</div>
						</div>
					</div>
				);
			})}
		</div>
	);
}

export default memo(App);
